import { useState, useEffect } from "react";
import { useFormContext, Controller, useFieldArray } from "react-hook-form";
import { Grid, Typography } from "@mui/material";
import PropTypes from "prop-types";
import ToggleInput from "../FormInputs/ToggleInput";
import CheckboxInput from "../FormInputs/CheckboxInput";
import StaffInfoModal from "./StaffInfoModal"
import StaffInfoInputs from "./StaffInfoInputs";

FormStaffInfoFieldWithContracted.propTypes = {
  fieldName: PropTypes.string,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
  fieldAttributes: PropTypes.object,
}

export default function FormStaffInfoFieldWithContracted({ fieldName, focusedField, setFocusedField, fieldAttributes }) {
  const { control, watch, setValue, getValues } = useFormContext();
  const [isEditable, setIsEditable] = useState(false);
  const [isVacantFieldEditable, setIsVacantFieldEditable] = useState(false);
  const [isContractedFieldEditable, setIsContractedFieldEditable] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const isVacant = watch(`${fieldName}.isVacant`);
  const isContracted = watch(`${fieldName}.contracted`);

  const { fields } = useFieldArray({
    keyName: '_id',
    control,
    name: `${fieldName}.staffMembers`,
  });

  useEffect(() => {
    if (!fieldAttributes.isEditable) {
      setIsEditable(false);
      setIsVacantFieldEditable(false);
      setIsContractedFieldEditable(false);
    }
    else {
      setIsEditable(!isVacant && !isContracted);
      setIsVacantFieldEditable(!isContracted);
      setIsContractedFieldEditable(!isVacant);
    } 

    const fieldNames = ['firstName', 'lastName', 'cellPhone', 'email'];
    const hasFieldsFilled = fields.some((_, index) => fieldNames.some(x => !!getValues(`${fieldName}.staffMembers[${index}].${x}`)));

    if ((isVacant || isContracted ) && hasFieldsFilled) setOpenModal(true)

  }, [isVacant, isContracted]);

  const onProceed = () => {
    fields.forEach((_, index) => {
      setValue(`${fieldName}.staffMembers[${index}].firstName`, null);
      setValue(`${fieldName}.staffMembers[${index}].lastName`, null);
      setValue(`${fieldName}.staffMembers[${index}].cellPhone`, null, {shouldValidate: true});
      setValue(`${fieldName}.staffMembers[${index}].email`, null, { shouldValidate: true });
    });
    setOpenModal(false);
  }

  const onClose = () => {
    setValue(`${fieldName}.isVacant`, false);
    setValue(`${fieldName}.contracted`, false);
    setOpenModal(false)
  }

  return <Grid>
    <Grid container>
      <Grid item >
        <Typography variant='subtitle1' color="text.secondary">
          {fieldAttributes.questionTitle}
        </Typography>
      </Grid>
      <Grid item sx={{ ml: 'auto', mr: 1 }}>
        <Controller
          name={`${fieldName}.isVacant`}
          control={control}
          render={() => (
            <ToggleInput
              fieldAttributes={{ ...fieldAttributes, label: 'Vacant', isEditable: isVacantFieldEditable }}
              fieldName={`${fieldName}.isVacant`}
            />
          )}
        />
      </Grid>
    </Grid>
    {
      fields.map((_, index) => (
        <StaffInfoInputs
          key={index}
          fieldName={`${fieldName}.staffMembers[${index}]`}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
          fieldAttributes={fieldAttributes}
          isEditable={isEditable}
        />
      ))
    }
    <Grid sx={{mt: 0.5} }>
      <Controller
        name={`${fieldName}.contracted`}
        control={control}
        render={() => (
          <CheckboxInput
            fieldAttributes={{ ...fieldAttributes, label: 'Contracted', isEditable: isContractedFieldEditable }}
            fieldName={`${fieldName}.contracted`}
          />
        )}
      />
    </Grid>
    <StaffInfoModal
      openModal={openModal}
      setOpenModal={setOpenModal}
      onProceed={onProceed}
      onClose={onClose}
      fieldAttributes={fieldAttributes}
      label={isVacant ? "vacant" : "contracted"}
    />
  </Grid>
}